export const ADD_PURPOSE_DATA = 'ADD_PURPOSE_DATA';
export const CLEAR_PURPOSES = 'CLEAR_PURPOSES';

const INITIAL_STATE = {
  isLoaded: false,
  purposes: {},
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_PURPOSE_DATA:
      return {
        isLoaded: true,
        purposes: action.payload,
      };
    case CLEAR_PURPOSES:
      return INITIAL_STATE;
    default:
      return state;
  }
}
